export const SET_PAGE = 'SET_PAGE';

export const SET_CATEGORY = 'SET_CATEGORY';

export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';
export const SET_INGREDIENTS = 'SET_INGREDIENTS';

export const SET_FX_PLAYING = 'SET_FX_PLAYING';

export const SET_MEME = 'SET_MEME';

export const SET_MESSAGES = 'SET_MESSAGES';

export const SET_DRAWER = 'SET_DRAWER';
